module.exports = __webpack_public_path__ + "img/main-img@x2.55cdfcf.png";